import { apolloClient } from '../../apollo'

const state = {
  me: {}
}

const mutations = {
  setMe (state, { me }) {
    state.me = me

    if (this.getters['user/hasOrganization']) {
      this.commit('organization/setSelected', state.me.organizations[0])
    }
  }
}

const actions = {
  async fetchMe (context) {
    const { data } = await apolloClient.query({
      query: require('../../graphql/me.gql')
    })

    context.commit('setMe', {
      me: data.me
    })
  }
}

const getters = {
  hasOrganization (state) {
    return state.me.organizations && state.me.organizations.length > 0
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
